module.exports = __webpack_public_path__ + "7374c06cd9354dbbe4b841241556b1a5.svg";